module.exports = __webpack_public_path__ + "static/media/Forestry-BG-2nd-Layer-Two.b3b46e16.png";